import { BlankSingleSideEnum } from "../../../interfaces/blank";

export enum ApiBlankFaceEnum {
  FRONT = 1,
  BACK = 2,
  FRONT_BACK = 3,
}

export const formatBlankSingleSideToApi = (
  side: BlankSingleSideEnum,
): Exclude<ApiBlankFaceEnum, ApiBlankFaceEnum.FRONT_BACK> => {
  return side === BlankSingleSideEnum.BACK ? ApiBlankFaceEnum.BACK : ApiBlankFaceEnum.FRONT;
};

export const getBlankFace = (sides: BlankSingleSideEnum[]) => {
  const hasFrontSide = sides.includes(BlankSingleSideEnum.FRONT);
  const hasBackSide = sides.includes(BlankSingleSideEnum.BACK);

  if (hasFrontSide && hasBackSide) {
    return ApiBlankFaceEnum.FRONT_BACK;
  }

  if (hasBackSide) {
    return ApiBlankFaceEnum.BACK;
  }

  return ApiBlankFaceEnum.FRONT;
};
